import type { RouteName } from '@/router/RouteName'

/** default = 일반 학습지 만들기 / entrance-test = 입학고사(학습지형) 만들기 */
export type MakeVariant = 'default' | 'entrance-test'

export type MakeVariantCapabilities = {
  /** 화면에 노출하는 산출물 명사 */
  materialLabel: '학습지' | '시험지'
  /** step3 생성/수정 버튼과 확인 모달에 쓰는 액션 명사. 입학고사는 산출물(materialLabel '시험지')과 달리 '입학고사'로 노출한다 */
  createActionLabel: '학습지' | '입학고사'
  showConceptTab: boolean
  showRangeAndTagTop: boolean
  /** step3 "문제 영역 옵션" 섹션 노출 여부. false면 산출물 플래그도 전부 강제 off */
  showProblemAreaOptions: boolean
  /** step3 학습지 태그 선택 UI 노출 여부. false면 서버가 태그를 고정하므로 선택 UI를 숨긴다 */
  showTagSelector: boolean
  /** step1 "기존 출제 문제 제외" 옵션 노출 여부. false면 저장소 복원값도 강제 false */
  showExcludePrevious: boolean
  /** step1 시그니처 교재 탭 노출 여부 */
  showSignatureWorkbookTab: boolean
  /** step1 기출 업로드 탭 노출 여부 */
  showPaperUploadTab: boolean
  /** step1 연산 탭 노출 여부 */
  showArithmeticTab: boolean
  /** QR 옵션 지원 여부. false면 QR 토글 대신 미지원 문구를 노출하고 qrFlag·qrAvailable를 강제 off 한다 */
  supportsQr: boolean
  /** step3 만들기 요청이 사용할 생성 API */
  createApi: 'worksheet' | 'entranceTest'
  editApi: 'worksheet' | 'entranceTest'
  /** 생성 완료 후 destinationPath·entryPath가 둘 다 없을 때 이동할 라우트 */
  exitFallbackRouteName: keyof typeof RouteName
}

export const MAKE_VARIANT_CAPABILITIES = {
  default: {
    materialLabel: '학습지',
    createActionLabel: '학습지',
    showConceptTab: true,
    showRangeAndTagTop: true,
    showProblemAreaOptions: true,
    showTagSelector: true,
    showExcludePrevious: true,
    showSignatureWorkbookTab: true,
    showPaperUploadTab: true,
    showArithmeticTab: true,
    supportsQr: true,
    createApi: 'worksheet',
    editApi: 'worksheet',
    exitFallbackRouteName: 'academyShareScopeWorksheet',
  },
  'entrance-test': {
    materialLabel: '시험지',
    createActionLabel: '입학고사',
    showConceptTab: false,
    showRangeAndTagTop: false,
    showProblemAreaOptions: false,
    showTagSelector: false,
    showExcludePrevious: false,
    showSignatureWorkbookTab: false,
    showPaperUploadTab: false,
    showArithmeticTab: false,
    supportsQr: false,
    createApi: 'entranceTest',
    editApi: 'entranceTest',
    exitFallbackRouteName: 'entranceTestWorksheet',
  },
} as const satisfies Record<MakeVariant, MakeVariantCapabilities>
